var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollarRollUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "jacket",
    viewBox: "0 0 143.59 90.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pro_shirt",
    "data-name": "pro shirt"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(20.2, 0.4)",
    id: "collar_inside",
    "data-name": "collar inside",
    className: "cls-1",
    d: "M23,2.21C14.18,1.87,6.42.05,4.65.62,3.43,1,2.09,2.55,1.21,5.27a37.23,37.23,0,0,0,.33,16c.11.56,1.22,4,1.66,5.45a11.39,11.39,0,0,0,.56,1.47c9.31,24,38.7,36.68,38.7,36.68H60.88s29.39-12.71,38.7-36.68a9.06,9.06,0,0,0,.56-1.47c.44-1.48,1.55-4.89,1.66-5.45a35.44,35.44,0,0,0,.33-16C101.25,2.55,99.91,1,98.69.62,96.81.05,89.05,1.75,80.4,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.52,169.7c.22-.34.78-.91,1.45-1.93,3.46-8.18,5.13-16.58,3.35-24.87-.9-2.73-2.23-4.32-3.46-4.66-1.9-.57-9.7,1.14-18.4,1.59-13.28.57-44.06.57-57.33,0-8.82-.34-16.62-2.16-18.41-1.59-1.22.34-2.56,1.93-3.46,4.66a12.71,12.71,0,0,0-.55,1.93c-1.34,8.74,1,17.83,5.24,26.35C653.12,174.36,727.4,173.56,729.52,169.7Z",
    transform: "translate(-612.06 -137.86)",
    fill: "#fff",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeWidth: 0.53
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.51,142.9c0-.12.22-1-.22-.46-2.11,2.62-5.22,6.7-9.1,12.5-8.32,12.49-11.86,18.28-11.86,18.28s.11,38.38,5,54.85c18.41-1.82,44.14-31.68,57.33-25.55C670.44,197.52,626.63,174.58,633.51,142.9Z",
    transform: "translate(-612.06 -137.86)",
    fill: "#fff",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeWidth: 0.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.21,142.9c0-.12-.22-1,.22-.46,2.11,2.62,5.22,6.7,9.1,12.5,8.32,12.49,11.87,18.28,11.87,18.28s-.12,38.38-5,54.85c-18.41-1.82-44.14-31.68-57.33-25.55C697.39,197.52,741.2,174.58,734.21,142.9Z",
    transform: "translate(-612.06 -137.86)",
    fill: "#fff",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeWidth: 0.52
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollarRollUp);
export default __webpack_public_path__ + "static/media/collar-roll-up.0f266caa9758d6278d952fe5f88864dd.svg";
export { ForwardRef as ReactComponent };